import { useDispatch, useSelector } from "react-redux";
import PageTitle from "../components/PageTitle";
import Index from "../view/Checkout/Index";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import moment from "moment";
import { setCartClear } from "../redux/cart/cart.action";
import { convertToTitleCase, getCookie, getSlugByLang } from "../common/Helper";
import ToastAlert from "../common/ToastAlert";
import VerificationModal from "../view/Checkout/VerificationModal";
import { setEmailVerified, setLoading, setLogin, setLogout } from "../redux/user/user.action";
import { validateAll } from "indicative/validator";
import { Elements, useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import MBWayModal from "../view/Checkout/MBWayModal";
import MultiBancoModal from "../view/Checkout/MultiBancoModal";
import HomeIcon from "../components/Iocns/HomeIcon";


export default function CheckoutController() {

    const cart = useSelector((state) => state.cart);
    const user = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [cartDetail, setCartDetail] = useState({})
    const [productDetail, setProductDetail] = useState({})
    const [mainContactField, setMainContactField] = useState([])
    const [passengerField, setPassengerField] = useState([])
    const [passengers, setPassengers] = useState([]);
    const [selectedCountryOption, setSelectedCountryOption] = useState('PT');
    const [selectedLanguageOption, setSelectedLanguageOption] = useState('pt');
    const [phone, setPhone] = useState("");
    const [cartItem, setCartItem] = useState(null)
    const [showVerificatonModal, setShowVerificatonModal] = useState(false);
    const handleCloseVerificatonModal = () => setShowVerificatonModal(false);
    const [userLoginData, setUserLoginData] = useState({})
    const [breadcrumbList, setBreadcrumbList] = useState([
        {
            name: <HomeIcon />,
            url: '/'
        },
        {
            name: "Loading...",
        },
    ])
    const [totalGuest, setTotalGuest] = useState(0)
    const [strength, setStrength] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoginForm, setIsLoginForm] = useState(true);
    const [isAdmin, setIsAdmin] = useState(getCookie("is_admin_logged_in") ? true : false);
    const [step, setStep] = useState(1);
    const [state, setState] = useState({
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        error: [],
    })
    const {
        error, email, password
    } = state;

    const [verifyState, setVerifyState] = useState({
        otp: "",
        error: [],
    })
    const [activeTab, setActiveTab] = useState("card");

    const [canResend, setCanResend] = useState(true);
    const [timer, setTimer] = useState(0);
    const RESEND_TIMEOUT = 10 * 60 * 1000;  // 10 minutes
    const [timeLeft, setTimeLeft] = useState(270); // 4:30 in seconds
    const [showModal, setShowModal] = useState(false);
    const [MBtimeLeft, setMBTimeLeft] = useState(600); // 10 minuts in seconds
    const [paymentId, setPaymentId] = useState(null);
    const [MBpaymentId, setMBPaymentId] = useState(null);
    const [mbResponse, setMbResponse] = useState(null);
    const [isMBLoading, setIsMBLoading] = useState(false);
    const [showMBModal, setShowMBModal] = useState(false);
    let selLang = getSlugByLang(user?.language)
    const today = moment().format('YYYY-MM-DD');

    const [cardState, setCardState] = useState({
        card_number: "",
        card_holder: "",
        expiry_date: "",
        cvc: "",
        error: [],
    })

    const onChangeCard = (e) => {
        let value = e.target.value;
        setCardState({
            ...cardState,
            [e.target.name]: value
        })

    }

        useEffect(() => {
        setIsAdmin(getCookie("is_admin_logged_in") ? true : false)
    }, [getCookie("is_admin_logged_in")]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = "Are you sure you want to reload the page?";
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const changeValue = (e) => {
        let value = e.target.value;
        setState({
            ...state,
            [e.target.name]: value
        })
        if (e.target.name == 'password') {
            checkStrength(value);
        }
    }
    const handhandleShowPassword = (e) => {
        e?.preventDefault();
        setShowPassword(!showPassword)
    }

    const changeValueOtp = (e) => {
        let value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        setVerifyState({
            ...verifyState,
            [e.target.name]: numericValue
        })

        if (numericValue.length === 6) {
            verify(e, numericValue.trim());
        }
    }

    const handlePaste = (e) => {
        const pastedValue = e.clipboardData.getData('text');
        setVerifyState({
            ...verifyState,
            otp: pastedValue
        })
        verify(e, pastedValue.trim())
    };

    useEffect(() => {

        if (cart?.product != null) {
            setCartDetail(cart)
        } else {
            // navigate('/')
        }

    }, [cart, dispatch]);


    useEffect(() => {
        const handleStorageChange = (event) => {

            if (event.key === "persist:toursxplorer-tourist") {
                window.location.reload();
            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, [dispatch]);


    const getCurrentUserFieldVal = (field) => {
        if (user?.token) {
            if (field == "phoneNumber") {
                return user?.userDetails?.phone ? user?.userDetails?.phone : ""
            } else if (field == "country" || field == "nationality") {
                return user?.userDetails?.country_code ? user?.userDetails?.country_code?.toUpperCase() : ""
            } else if (field == "firstName") {
                return user?.userDetails?.first_name ? user?.userDetails?.first_name : ""
            } else if (field == "lastName") {
                return user?.userDetails?.last_name ? user?.userDetails?.last_name : ""
            } else {
                return ""
            }
        } else {
            return ""
        }

    }

    const fillPassangerDetail = (passanger, field, catBookingId) => {
        if (passanger && passanger.length > 0) {


            let filledFields = passanger.filter((e) => Number(e?.catBookingId) == Number(catBookingId))?.length > 0 ? passanger.filter((e) => e.catBookingId == catBookingId)[0]?.fields : []

            if (filledFields.length > 0 && field) {

                let fieldValInd = filledFields?.findIndex((e) => e.field_name == field)
                if (fieldValInd != -1) {
                    return filledFields[fieldValInd]?.value
                }


            }
        }
        return "";


    }


    const getRecordDetails = async (id) => {
        setIsLoading(true)
        let data = {};
        data.product_id = id
        if (localStorage.getItem('mb_way_payment_request_id')) {
            data.mb_way_payment_request_id = localStorage.getItem('mb_way_payment_request_id')
        }
        if (localStorage.getItem('mb_payment_request_id')) {
            data.mb_payment_request_id = localStorage.getItem('mb_payment_request_id')
        }


        const fetchrecordDetail = await ApiCall('post', 'product-checkout-info', data)
        if (fetchrecordDetail) {
            if (fetchrecordDetail?.data?.success) {
                setProductDetail(fetchrecordDetail.data.product)
                let mainContDetail = fetchrecordDetail?.data?.checkoutFormDetail != null ? (fetchrecordDetail?.data?.checkoutFormDetail?.main_contact_details ? JSON.parse(fetchrecordDetail?.data?.checkoutFormDetail?.main_contact_details) : null) : null
                // console.log(mainContDetail);

                setMainContactField(
                    fetchrecordDetail.data.product?.product_extra_info
                        .filter((e) => e.field_for == 0)
                        .map((field) => ({
                            ...field,
                            value: mainContDetail ? mainContDetail[field?.field_name] ? mainContDetail[field?.field_name] : getCurrentUserFieldVal(field?.field_name) : getCurrentUserFieldVal(field?.field_name),
                            error: ""
                        }))
                );
                let sl = getSlugByLang(user?.language)
                setBreadcrumbList([
                    {
                        name: <HomeIcon />,
                        url: '/' + sl
                    },
                    {
                        name: fetchrecordDetail.data.product?.title,
                        url: '/' + sl + '/tour/' + fetchrecordDetail.data.product?.slug
                    },
                    {
                        name: "Checkout",
                    },
                ])
                // setMainContactField(fetchrecordDetail.data.product?.product_extra_info.filter((e)=>e.field_for == 0))
                setPassengerField(fetchrecordDetail.data.product?.product_extra_info.filter((e) => e.field_for == 1))
                let passanger = fetchrecordDetail?.data?.checkoutFormDetail != null ? (fetchrecordDetail?.data?.checkoutFormDetail?.passengers ? JSON.parse(fetchrecordDetail?.data?.checkoutFormDetail?.passengers) : []) : []
                // console.log(passanger);

                let list = [];
                let counter = 1;
                let passengerFields = fetchrecordDetail.data.product?.product_extra_info.filter((e) => e.field_for == 1)
                let totalG = 0;
                cart.people.forEach(category => {
                    for (let i = 0; i < category.qty; i++) {
                        totalG++
                        let catBookingId = null;
                        let catBookings = cartItem?.pricingCategoryBookings.filter(item => item.pricingCategoryId === category.catId);
                        catBookings = catBookings?.length > 0 ? catBookings[i] : {}

                        if (catBookings) {
                            catBookingId = catBookings?.id
                        }
                        // console.log(catBookingId);

                        // let filledFields = passanger.filter((e) => Number(e?.catBookingId) == Number(catBookingId))?.length > 0 ? passanger.filter((e) => e.catBookingId == catBookingId)[0]?.fields : []
                        // console.log(filledFields);

                        list.push({
                            id: counter++,
                            type: category.title,
                            cat: category.cat,
                            catBookingId: catBookingId,
                            fields: passengerFields.map(field => ({
                                field_name: field.field_name,
                                field: field.field,
                                required: field.required,
                                value: fillPassangerDetail(passanger, field?.field_name, catBookingId),
                                error: "",
                            }))
                        });
                    }
                });
                setTotalGuest(totalG)
                setPassengers(list);
                setIsLoading(false)

            } else {
                setIsLoading(false)
                // navigate(-1)
            }
        } else {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        (async () => {
            if (cartDetail?.product) {
                setIsLoading(true)
                await getUserCart()
            } else {
                // console.log(cartDetail);

                // navigate('/')
            }
        })();
    }, [cartDetail.product])

    //  console.log(cartDetail);
    useEffect(() => {
        (async () => {
            if (cartDetail.product) {
                await getRecordDetails(cartDetail.product)
            } else {
                // setIsLoading(false)
            }
        })();
    }, [cartItem])


    useEffect(() => {
        let sl = getSlugByLang(user?.language)
        setBreadcrumbList([
            {
                name: <HomeIcon />,
                url: '/' + sl
            },
            {
                name: productDetail?.title,
                url: sl + '/tour/' + productDetail?.slug
            },
            {
                name: "Checkout",
            },
        ])
    }, [user?.language]);


    const handleChangePassenger = (id, fieldName, e) => {
        let value = e.target.value
        setPassengers((prevPassengers) =>
            prevPassengers.map((passenger) =>
                passenger.id === id
                    ? {
                        ...passenger,
                        fields: passenger.fields.map(field =>
                            field.field_name === fieldName
                                ? { ...field, value }
                                : field
                        )
                    }
                    : passenger
            )
        );
    };

    const handleChangeMainContact = (ind = null, fieldName = null, e) => {
        setMainContactField((prevFields) =>
            prevFields.map((field) =>
                field.field_name === e.target.name
                    ? { ...field, value: e.target.value }
                    : field
            )
        );
        // setShowVerificatonModal(true)
    };

    const handleCountrySelectChange = (idx, e, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            const selectedValue = e.target.value;
            setSelectedCountryOption(selectedValue);

            let val = selectedValue
            // let mFields = [...mainContactField]
            // let findInd = mFields.findIndex((e1) => e1.field_name == field_name)
            // if (findInd != -1) {
            //     mFields[findInd].value = val
            // }
            // setMainContactField(mFields)
            setMainContactField((prevFields) =>
                prevFields.map((field) =>
                    field.field_name === field_name
                        ? { ...field, value: val }
                        : field
                )
            );
        } else {
            handleChangePassenger(idx, field_name, e)
        }

    };

    const onChangeCustomDropdown = (ind, e, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            let val = e == 'Male' ? 'm' : 'f'
            if (field_name == "title") {
                val = e
            }

            setMainContactField((prevFields) =>
                prevFields.map((field) =>
                    field.field_name === field_name
                        ? { ...field, value: val }
                        : field
                )
            );
        } else {
            let ev = {}
            ev.target = {}
            ev.target.value = e == 'Male' ? 'm' : 'f'
            if (field_name == "title") {
                ev.target.value = e
            }
            handleChangePassenger(ind, field_name, ev)
        }
    };

    const onChangeDate = (ind, e, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            let val = e
            // let mFields = [...mainContactField]
            // let findInd = mFields.findIndex((e1) => e1.field_name == field_name)
            // if (findInd != -1) {
            //     mFields[findInd].value = val
            // }
            // setMainContactField(mFields)
            setMainContactField((prevFields) =>
                prevFields.map((field) =>
                    field.field_name === field_name
                        ? { ...field, value: val }
                        : field
                )
            );
        } else {
            let ev = {}
            ev.target = {}
            ev.target.value = e
            handleChangePassenger(ind, field_name, ev)
        }


    };

    const handleLanguageSelectChange = (ind, e, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            const selectedValue = e.target.value;
            setSelectedLanguageOption(selectedValue);

            let val = selectedValue
            // let mFields = [...mainContactField]
            // let findInd = mFields.findIndex((e1) => e1.field_name == field_name)
            // if (findInd != -1) {
            //     mFields[findInd].value = val
            // }
            // setMainContactField(mFields)

            setMainContactField((prevFields) =>
                prevFields.map((field) =>
                    field.field_name === field_name
                        ? { ...field, value: val }
                        : field
                )
            );
        } else {
            handleChangePassenger(ind, field_name, e)
        }
    };

    const handleNumberChange = (ind, e, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            let val = e
            // let mFields = [...mainContactField]
            // let findInd = mFields.findIndex((e1) => e1.field_name == field_name)
            // if (findInd != -1) {
            //     mFields[findInd].value = val
            // }
            // setMainContactField(mFields)
            setMainContactField((prevFields) =>
                prevFields.map((field) =>
                    field.field_name === field_name
                        ? { ...field, value: val }
                        : field
                )
            );
        } else {
            let ev = {}
            ev.target = {}
            ev.target.value = e
            handleChangePassenger(ind, field_name, ev)
        }
    };

    const handleValidityChange = (isValid, id, field_name, form) => {
        if (form == "MAIN_CONTACT") {
            if (!isValid) {
                setMainContactField((prevFields) =>
                    prevFields.map((field) =>
                        field.field_name === field_name && field.value != ''
                            ? { ...field, error: "Invalid phone number" }
                            : field
                    )
                );
            } else {
                setMainContactField((prevFields) =>
                    prevFields.map((field) =>
                        field.field_name === field_name
                            ? { ...field, error: "" }
                            : field
                    )
                );
            }
        } else {
            if (!isValid) {

                setPassengers((prevPassengers) =>
                    prevPassengers.map((passenger) =>
                        passenger.id === id
                            ? {
                                ...passenger,
                                fields: passenger.fields.map(field =>
                                    field.field_name === field_name && field.value != ''
                                        ? { ...field, error: "Invalid phone number" }
                                        : field
                                )
                            }
                            : passenger
                    )
                );

            } else {
                setPassengers((prevPassengers) =>
                    prevPassengers.map((passenger) =>
                        passenger.id === id
                            ? {
                                ...passenger,
                                fields: passenger.fields.map(field =>
                                    field.field_name === field_name
                                        ? { ...field, error: "" }
                                        : field
                                )
                            }
                            : passenger
                    )
                );
            }


        }
        // console.log('isValid', isValid);

        // if (phone) {
        //     if (!isValid) {
        //         // setPhoneError('Invalid phone number')
        //     } else {
        //         // setPhoneError('')

        //     }
        // }
    };

    const getUserCart = async () => {
        let data = {}
        data.cartSession = cartDetail?.cartSession
        const fetchCart = await ApiCall('post', 'get-cart', data);
        if (fetchCart) {
            if (fetchCart?.data?.success) {
                if (fetchCart.data.cart?.length > 0) {
                    let cartItem = fetchCart.data.cart[0];
                    setCartItem(cartItem)
                } else {
                    dispatch(setCartClear())
                    navigate('/')
                }

            } else {
                dispatch(setCartClear())
                navigate('/')
            }
        }
    }



    const validateField = (field, value) => {
        let errorMessage = "";

        switch (field) {
            case "email":
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!value) {
                    errorMessage = "Email is required.";
                } else if (!emailPattern.test(value)) {
                    errorMessage = "Enter a valid email.";
                }
                break;

            case "phoneNumber":
                if (!value) {
                    errorMessage = "Phone number is required.";
                }
                break;

            case "dateOfBirth":
                if (!value) {
                    errorMessage = "Date of Birth is required.";
                }
                break;

            default:
                if (field && !value) {
                    errorMessage = `${convertToTitleCase(field)} is required.`;
                }
        }

        return errorMessage;
    };



    const verifyBookingInfo = () => {
        const formaerrror = {};
        if (!user.token) {
            let checkEmail = validateField('email', state.email);
            let checkPass = validateField('password', state.password);
            let checkFname = validateField('first_name', state.first_name);
            let checkLname = validateField('last_name', state.last_name);


            const formaerrror = {};
            if (checkEmail) {
                formaerrror['email'] = checkEmail
            }
            if (checkPass) {
                formaerrror['password'] = checkPass
            }

            if (!(strength >= 5)) {
                formaerrror['password'] = 'Please enter strong password'
            }

            if (!isLoginForm) {
                if (checkFname) {
                    formaerrror['first_name'] = checkFname
                }
                if (checkLname) {
                    formaerrror['last_name'] = checkLname
                }
            }

            setState({
                ...state,
                error: formaerrror
            })
        }



        let mFields = [...mainContactField];
        let getRequiredFields = mFields.filter((e) => e.required == true &&
            typeof e?.value == "string" ? e?.value?.trim() == "" : e?.value == null
        );

        if (getRequiredFields.length > 0) {
            setMainContactField((prevFields) =>
                prevFields.map((field) => ({
                    ...field,
                    error: field.required && (typeof field?.value == "string" ? field.value?.trim() === "" : field?.value == null) ? `${convertToTitleCase(field.field)} is required` : "",
                }))
            );
        } else {
            setMainContactField((prevFields) =>
                prevFields.map((field) => ({
                    ...field,
                    error: "",
                }))
            );
        }

        let pFields = [...passengers];


        // Filter required fields that are empty
        let getRequiredPassengerFields = pFields.flatMap((passenger) =>
            passenger.fields.filter((e) => e.required == true &&
                typeof e?.value == "string" ? e?.value?.trim() == "" : e?.value == null
            )
        );


        if (getRequiredPassengerFields.length > 0) {
            setPassengers((prevPassengers) =>
                prevPassengers.map((passenger) => ({
                    ...passenger,
                    fields: passenger.fields.map((field) => ({
                        ...field,
                        error: field.required &&
                            (typeof field?.value == "string" ? field.value?.trim() === "" : field?.value == null) ? `${convertToTitleCase(field.field)} is required` : "",
                    })),
                }))
            );
        } else {
            setPassengers((prevPassengers) =>
                prevPassengers.map((passenger) => ({
                    ...passenger,
                    fields: passenger.fields.map((field) => ({
                        ...field,
                        error: "",
                    })),
                }))
            );
        }

        if (getRequiredFields.length > 0 || getRequiredPassengerFields.length > 0) {
            return false;
        }

        if (Object.keys(formaerrror).length) {
            return false;
        }
        setState({
            ...state,
            error: formaerrror
        })



        const storedQuestions = mainContactField.reduce((acc, { field_name, value }) => {
            if (field_name === "passportExpiry" || field_name === "dateOfBirth") {
                acc[field_name] = value ? moment(value).format("YYYY-MM-DD") : '';
            } else if (field_name === "title") {
                acc[field_name] = value?.toUpperCase()
            } else {
                acc[field_name] = value;
            }
            return acc;
        }, {});

        const passangerformattedData = passengers.map(person => ({
            ...person,
            fields: person.fields.map(field => ({
                ...field,
                value: (field.field_name === "passportExpiry" || field.field_name === "dateOfBirth")
                    ? (field.value ? moment(field.value).format("YYYY-MM-DD") : '')
                    : (field.field_name === "title") ? field.value?.toUpperCase()
                        : field.value
            }))
        }));

        localStorage.removeItem('lastSentTime');

        (async () => {
            dispatch(setLoading(true))
            let cartData = {}
            cartData.cartSession = cartDetail?.cartSession
            const fetchCart = await ApiCall('post', 'get-cart', cartData);

            if (fetchCart) {
                if (fetchCart?.data?.success) {
                    if (fetchCart.data.cart?.length > 0) {
                        let checkoutData = {}
                        checkoutData.cartSession = cartDetail?.cartSession
                        checkoutData.mainContact = storedQuestions
                        checkoutData.passangers = passangerformattedData
                        if (state.email && state.password) {
                            checkoutData.email = state.email
                            checkoutData.password = state.password
                        }
                        checkoutData.isLoginForm = isLoginForm
                        if (!isLoginForm) {
                            checkoutData.first_name = state.first_name
                            checkoutData.last_name = state.last_name
                        }
                        checkoutData.isLoggedIn = user?.token ? true : false;
                        const checkout = await ApiCall('post', 'verify-booking-info', checkoutData);
                        dispatch(setLoading(false))
                        if (checkout) {
                            if (checkout?.data?.success) {
                                if (checkout?.data?.userType && checkout?.data?.user && checkout?.data?.userType != "ALREADY_LOGGED_IN") {

                                    if (checkout?.data?.userType == 'LOGIN') {
                                        let dispatchData = {}
                                        dispatchData.userDetails = checkout.data.user
                                        dispatchData.token = checkout.data.token
                                        dispatchData.tempEmail = checkout.data.user.email
                                        // dispatch(setLogin(dispatchData))
                                        setUserLoginData(dispatchData)

                                        if (checkout.data.user.email_verified_at == "" || checkout.data.user.email_verified_at == null) {
                                            dispatch(setEmailVerified(false))
                                            ToastAlert({ msg: 'Please verify otp that we sent you in email', msgType: 'info' });
                                            setShowVerificatonModal(true)

                                        } else {
                                            dispatch(setLogin(dispatchData))
                                            dispatch(setEmailVerified(true))
                                            // ToastAlert({ msg: 'Go To Payments', msgType: 'info' });
                                            setStep(2)
                                        }
                                    } else {
                                        ToastAlert({ msg: 'Please verify otp that we sent you in email', msgType: 'info' });
                                        let dispatchData = {}
                                        dispatchData.userDetails = checkout.data.user
                                        dispatchData.token = checkout.data.token
                                        dispatchData.tempEmail = checkout.data.user.email
                                        // dispatch(setLogin(dispatchData))
                                        setUserLoginData(dispatchData)
                                        dispatch(setEmailVerified(false))
                                        setShowVerificatonModal(true)

                                    }

                                } else {
                                    // ToastAlert({ msg: 'Go To Payments', msgType: 'info' });
                                    setStep(2)
                                }
                            } else {

                                if (checkout?.data?.message?.fields?.errors?.length > 0) {

                                    let errors = checkout?.data?.message?.fields?.errors

                                    setMainContactField((prevFields) =>
                                        prevFields.map((field) => {
                                            // Find an error that matches the field_name
                                            let errorObj = errors.find(
                                                (err) => err.path.includes("mainContactDetails") && err.questionId === field.field_name
                                            );

                                            return {
                                                ...field,
                                                error: errorObj ? errorObj.message : "", // Set error message if found, else empty
                                            };
                                        })
                                    );


                                    setPassengers((prevPassengers) =>
                                        prevPassengers.map((passenger, passengerIndex) => {
                                            // Filter errors that contain 'passengerDetails' in the path
                                            let passengerErrors = errors.filter((err) =>
                                                err.path.includes("passengerDetails")
                                            );

                                            return {
                                                ...passenger,
                                                fields: passenger.fields.map((field) => {
                                                    // Find error for this field by extracting passenger index
                                                    let errorObj = passengerErrors.find((err) => {
                                                        const match = err.path.match(/passengers\/(\d+)\/passengerDetails/);
                                                        return match && parseInt(match[1]) === passengerIndex && err.questionId === field.field_name;
                                                    });

                                                    return {
                                                        ...field,
                                                        error: errorObj
                                                            ? errorObj.reason === "INVALID"
                                                                ? errorObj.message // Use provided message if invalid
                                                                : `${convertToTitleCase(field.field)} is required` // Default message for missing fields
                                                            : "",
                                                    };
                                                }),
                                            };
                                        })
                                    );


                                } else {

                                    if (checkout?.data?.message) {
                                        ToastAlert({ msg: checkout?.data?.message, msgType: 'error' });
                                        // dispatch(setCartClear())
                                        // navigate('/')
                                        // const formaerrror = {};
                                        // formaerrror.email = checkout.data.message
                                        // setState({
                                        //     ...state,
                                        //     error: formaerrror,
                                        // })

                                    } else {
                                        ToastAlert({ msg: "Oops ! not able to booking at this moment, please try again", msgType: 'error' });
                                        dispatch(setCartClear())
                                        navigate('/')
                                    }

                                }

                            }
                        }

                    } else {
                        dispatch(setLoading(false))
                        ToastAlert({ msg: "Oops ! All slots are booked , please try another slot", msgType: 'error' });
                        dispatch(setCartClear())
                        navigate('/')
                    }

                } else {
                    dispatch(setLoading(false))
                    ToastAlert({ msg: "Oops ! All slots are booked , please try another slot", msgType: 'error' });
                    // dispatch(setCartClear())
                    // navigate('/')
                }
            }
        })();

    }

    const verify = (e, code = null) => {

        e?.preventDefault();

        const rules = {
            otp: 'required|min:6|max:6',

        }
        let stateData = {
            otp: String(code) ?? String(verifyState.otp)
        }

        const message = {
            'otp.required': 'code is Required.',
            'otp.min': 'The code must be exactly 6 characters long',
            'otp.max': 'The code must be exactly 6 characters long',
        }

        validateAll(stateData, rules, message).then(async () => {
            dispatch(setLoading(true))
            const formaerrror = {};
            // setState({
            //     ...state,
            //     error: formaerrror,
            //     otp: stateData.otp
            // })

            let data = {}
            data.otp = stateData.otp

            const verifyOtp = await ApiCall('post', 'verify-register', data, userLoginData.token)

            if (verifyOtp) {
                dispatch(setLoading(false))
                if (verifyOtp?.data?.success) {

                    localStorage.removeItem('lastSentTime');
                    // ToastAlert({ msg: verifyOtp.data.message, msgType: 'success' });
                    // navigate('/home')
                    dispatch(setLogin(userLoginData))
                    dispatch(setEmailVerified(true))
                    setShowVerificatonModal(false)
                    ToastAlert({ msg: verifyOtp.data.message, msgType: 'success' });
                    setStep(2)

                } else {

                    if (verifyOtp?.data?.errors && Object.keys(verifyOtp?.data?.errors).length) {

                        setVerifyState({
                            ...verifyState,
                            error: verifyOtp.data.errors,
                        })

                    } else {
                        const formaerrror = {};
                        formaerrror.otp = verifyOtp.data.message
                        setVerifyState({
                            ...verifyState,
                            error: formaerrror,
                            otp: stateData.otp
                        })
                        // ToastAlert({ msg: verifyOtp.data.message, msgType: 'error' });
                    }
                }
            } else {
                dispatch(setLoading(false))
                ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
            }



        }).catch(errors => {
            dispatch(setLoading(false))
            const formaerrror = {};
            if (errors.length) {
                errors.forEach(element => {
                    formaerrror[element.field] = element.message
                });
            } else {
                ToastAlert({ msg: errors?.message ?? 'Something went wrong', msgType: 'error' });
            }

            setVerifyState({
                ...verifyState,
                error: formaerrror,
                otp: stateData.otp
            })

        });

    }


    const resendOtp = async () => {

        dispatch(setLoading(true))
        const resendVerificationOtp = await ApiCall('post', 'resend-register-otp', null, userLoginData.token)
        if (resendVerificationOtp) {
            dispatch(setLoading(false))
            if (resendVerificationOtp?.data?.success) {
                localStorage.setItem('lastSentTime', Date.now());
                setCanResend(false);
                setTimer(RESEND_TIMEOUT / 1000);
                ToastAlert({ msg: resendVerificationOtp.data.message, msgType: 'success' });

            } else {

                // ToastAlert({ msg: resendVerificationOtp.data.message, msgType: 'error' });
                const formaerrror = {};
                formaerrror.otp = resendVerificationOtp.data.message
                setState({
                    ...state,
                    error: formaerrror,
                })
            }
        } else {
            dispatch(setLoading(false))
            ToastAlert({ msg: 'Something went wrong', msgType: 'error' });
        }

    }


    useEffect(() => {
        dispatch(setLoading(false))
        let isMounted = true;
        // console.log('1')
        const lastSentTime = localStorage.getItem('lastSentTime');
        // console.log('2')
        if (lastSentTime) {
            // console.log('3')
            const timePassed = Date.now() - lastSentTime;

            if (timePassed < RESEND_TIMEOUT) {
                // console.log('4')
                setCanResend(false);
                setTimer(Math.ceil((RESEND_TIMEOUT - timePassed) / 1000)); // Set timer in seconds
            } else {
                // console.log('5')
                localStorage.removeItem('lastSentTime'); // Clear if timeout passed
                // console.log('6')

            }
        }
        return () => {
            // console.log('7')
            isMounted = false; // clean up
        };
    }, []);

    useEffect(() => {
        let isMounted1 = true;
        // console.log('8')
        let countdown;
        if (!canResend && timer > 0) {
            // console.log('9')
            countdown = setInterval(() => {
                // console.log('10')
                setTimer(prev => {
                    // console.log('11')
                    if (prev <= 1) {
                        // console.log('12')
                        setCanResend(true);
                        clearInterval(countdown);
                        localStorage.removeItem('lastSentTime'); // Clear timestamp when cooldown ends
                        // console.log('13')
                        return 0;

                    }
                    // console.log('14')
                    return prev - 1;

                });
            }, 1000);
        }
        return () => {
            // console.log('15')
            isMounted1 = false; // clean up
            clearInterval(countdown)
            // console.log('16')
        };
    }, [canResend, timer]);

    const formatTime = (seconds) => {
        return moment.utc(seconds * 1000).format("m:ss"); // Convert seconds to milliseconds for Moment.js
    };


    const checkStrength = (password) => {
        let score = 0;
        let hasUpper = /[A-Z]/.test(password);
        let hasLower = /[a-z]/.test(password);
        let hasNumber = /[0-9]/.test(password);
        let hasSpecial = /[^A-Za-z0-9]/.test(password);
        let isLong = password.length >= 8;
        let isVeryLong = password.length >= 12;

        // Assign points for complexity
        if (hasLower) score++;
        if (hasUpper) score++;
        if (hasSpecial) score++;
        if (hasNumber) score++; // Ensure number is required for stronger passwords

        // Add points only when length is 8+
        if (isLong) score++;
        if (isVeryLong) score++;

        setStrength(score);
    };

    const getClassNames = (index) => {
        if (password.length === 0) {
            return 'comSpan';
        }

        const classNames = ['comSpan'];

        if (strength >= 1) {
            classNames[0] = 'comSpan redSpan';
        }
        if (strength >= 2) {
            classNames[1] = 'comSpan yellowSpan';
        }
        if (strength >= 5) {
            classNames[2] = 'comSpan greenSpan';
        }
        return classNames[index] || 'comSpan';
    };

    const onClickPaymentTab = (tab) => {
        setActiveTab(tab)
    }

    const onClickContinue = async () => {

        if (step == 1) {
            await verifyBookingInfo()
        } else {
            await checkout()
        }
    }

    const checkout = async (paymentRes = null) => {
        const userLang = getSlugByLang(user?.language)
        const storedQuestions = mainContactField.reduce((acc, { field_name, value }) => {
            if (field_name === "passportExpiry" || field_name === "dateOfBirth") {
                acc[field_name] = value ? moment(value).format("YYYY-MM-DD") : '';
            } else if (field_name === "title") {
                acc[field_name] = value?.toUpperCase()
            } else {
                acc[field_name] = value;
            }
            return acc;
        }, {});

        const passangerformattedData = passengers.map(person => ({
            ...person,
            fields: person.fields.map(field => ({
                ...field,
                value: (field.field_name === "passportExpiry" || field.field_name === "dateOfBirth")
                    ? (field.value ? moment(field.value).format("YYYY-MM-DD") : '')
                    : (field.field_name === "title") ? field.value?.toUpperCase()
                        : field.value
            }))
        }));

        let cartData = {}
        cartData.cartSession = cartDetail?.cartSession
        dispatch(setLoading(true))
        const fetchCart = await ApiCall('post', 'get-cart', cartData);
        if (fetchCart) {
            if (fetchCart?.data?.success) {
                if (fetchCart?.data?.cart?.length > 0) {
                    let checkoutData = {}
                    checkoutData.cartSession = cartDetail?.cartSession
                    checkoutData.mainContact = storedQuestions
                    checkoutData.passangers = passangerformattedData
                    checkoutData.supplier_id = productDetail?.supplier_id
                    checkoutData.payment_type = activeTab == "paypalint" ? 'paypal' : activeTab
                    checkoutData.activity_date = cartDetail?.selectedDate
                    checkoutData.product_id = cartDetail?.product
                    checkoutData.commission = productDetail?.commission

                    if (paymentRes) {
                        checkoutData.transaction_id = paymentRes?.transaction_id
                        checkoutData.transaction_details = paymentRes?.transaction_details
                    }

                    const checkout = await ApiCall('post', 'checkout', checkoutData, user.token ? user.token : userLoginData?.token);
                    dispatch(setLoading(false))
                    if (checkout) {
                        if (checkout?.data?.success) {
                            if (checkout.data?.message?.booking?.status == "CONFIRMED") {
                                ToastAlert({ msg: "Tour Booked Successfully!", msgType: 'success' });
                            } else {
                                ToastAlert({ msg: "Tour Booked! You will be notified once supplier will confirm", msgType: 'success' });
                            }
                            navigate(('/' + userLang) + '/booking-success/' + checkout?.data?.booking_id)
                        } else {

                            if (checkout?.data?.message?.fields?.errors?.length > 0) {

                                let errors = checkout?.data?.message?.fields?.errors

                                setMainContactField((prevFields) =>
                                    prevFields.map((field) => {
                                        // Find an error that matches the field_name
                                        let errorObj = errors.find(
                                            (err) => err.path.includes("mainContactDetails") && err.questionId === field.field_name
                                        );

                                        return {
                                            ...field,
                                            error: errorObj ? errorObj.message : "", // Set error message if found, else empty
                                        };
                                    })
                                );


                                setPassengers((prevPassengers) =>
                                    prevPassengers.map((passenger, passengerIndex) => {
                                        // Filter errors that contain 'passengerDetails' in the path
                                        let passengerErrors = errors.filter((err) =>
                                            err.path.includes("passengerDetails")
                                        );

                                        return {
                                            ...passenger,
                                            fields: passenger.fields.map((field) => {
                                                // Find error for this field by extracting passenger index
                                                let errorObj = passengerErrors.find((err) => {
                                                    const match = err.path.match(/passengers\/(\d+)\/passengerDetails/);
                                                    return match && parseInt(match[1]) === passengerIndex && err.questionId === field.field_name;
                                                });

                                                return {
                                                    ...field,
                                                    error: errorObj
                                                        ? errorObj.reason === "INVALID"
                                                            ? errorObj.message // Use provided message if invalid
                                                            : `${convertToTitleCase(field.field)} is required` // Default message for missing fields
                                                        : "",
                                                };
                                            }),
                                        };
                                    })
                                );


                            } else {

                                if (checkout?.data?.message) {
                                    ToastAlert({ msg: checkout?.data?.message, msgType: 'error' });
                                    // dispatch(setCartClear())
                                    navigate('/')

                                } else {
                                    ToastAlert({ msg: "Oops ! not able to booking at this moment, please try again", msgType: 'error' });
                                    // dispatch(setCartClear())
                                    navigate('/')
                                }

                            }

                        }
                    }

                } else {
                    ToastAlert({ msg: "Oops ! All slots are booked , please try another slot", msgType: 'error' });
                    dispatch(setCartClear())
                    navigate('/')
                }

            } else {
                dispatch(setLoading(false))
                ToastAlert({ msg: "Oops ! All slots are booked , please try another slot", msgType: 'error' });
                dispatch(setCartClear())
                navigate('/')
            }
        } else {
            dispatch(setLoading(false))
        }


    }

    const stripeSuccess = async (data = null) => {
        await checkout(data)
    }

    // MB WAY RESPONSE TIMER : 


    const resetTimer = () => {
        setShowModal(false);
        setPaymentId(null);
    };

    const resetMBTimer = () => { // for Multibanco
        setShowMBModal(false);
        setMBPaymentId(null);
    };

    const handleMBExpiration = () => { // for Multibanco
        ToastAlert({ msg: "Payment Request is Expired, Please try again", msgType: "error" });
        localStorage.removeItem("mb_payment_start_time");
        localStorage.removeItem("mb_payment_id");
        localStorage.removeItem("mb_ref");
        localStorage.removeItem("mb_exp");
        setStep(1)
        setPaymentId(null);
        setMBTimeLeft(600); // Reset timer
        setShowMBModal(false); // Close modal
        resetMBTimer(); // Reset parent state
    };

    const handleExpiration = () => {
        ToastAlert({ msg: "Payment Request is Expired, Please try again", msgType: "error" });
        localStorage.removeItem("payment_start_time");
        localStorage.removeItem("payment_id");
        setStep(1)
        setPaymentId(null);
        setTimeLeft(270); // Reset timer
        setShowModal(false); // Close modal
        resetTimer(); // Reset parent state
    };

    useEffect(() => {
        const storedTime = localStorage.getItem("payment_start_time");
        const payId = localStorage.getItem('payment_id')
        let interval;
        if (payId) {
            if (storedTime) {
                const elapsedTime = Math.floor((Date.now() - storedTime) / 1000);
                const remainingTime = Math.max(0, 270 - elapsedTime);
                setTimeLeft(remainingTime);

                if (remainingTime === 0) {
                    // ToastAlert({ msg: "Payment Request is Expired, Please try again", msgType: 'error' });
                    // localStorage.removeItem("payment_start_time");
                    // localStorage.removeItem("payment_id");
                    // setPaymentId(null)
                    // setTimeLeft(270); // Reset timer
                    // setShowModal(false); // Close modal
                    handleExpiration()
                    return;
                }
            } else {
                localStorage.setItem("payment_start_time", Date.now());
            }

            interval = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev > 1) return prev - 1;


                    clearInterval(interval);
                    // localStorage.removeItem("payment_start_time");
                    // localStorage.removeItem("payment_id");
                    // setPaymentId(null)
                    // setTimeLeft(270);
                    // setShowModal(false);
                    // resetTimer(); // Reset parent state
                    handleExpiration()
                    return 0;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [resetTimer]);

    useEffect(() => { // Multibanco
        const storedTime = localStorage.getItem("mb_payment_start_time");
        const payId = localStorage.getItem('mb_payment_id')
        let interval;
        if (payId) {
            if (storedTime) {
                const elapsedTime = Math.floor((Date.now() - storedTime) / 1000);
                const remainingTime = Math.max(0, 600 - elapsedTime);
                setMBTimeLeft(remainingTime);

                if (remainingTime === 0) {
                    handleMBExpiration()
                    return;
                }
            } else {
                localStorage.setItem("mb_payment_start_time", Date.now());
            }

            interval = setInterval(() => {
                setMBTimeLeft((prev) => {
                    if (prev > 1) return prev - 1;


                    clearInterval(interval);

                    handleMBExpiration()
                    return 0;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [resetMBTimer]);


    useEffect(() => {
        const storedPaymentId = localStorage.getItem("payment_id");
        if (storedPaymentId) {
            setStep(2)
            setActiveTab('mb_way')
            setShowModal(true);
            setPaymentId(storedPaymentId);
        }
    }, []);

    useEffect(() => {
        const storedPaymentId = localStorage.getItem("mb_payment_id");
        if (storedPaymentId) {
            setStep(2)
            setActiveTab('multibanco')
            setShowMBModal(true)
            setMBPaymentId(storedPaymentId)
        }
    }, []);

    useEffect(() => {
        const checkPaymentStatus = async () => {
            if (!paymentId) return;
            const userLang = getSlugByLang(user?.language)
            const response = await ApiCall("post", "check-mb-way-request-status", { id: paymentId }, user.token ? user.token : userLoginData?.token);
            if (response?.data?.success) {
                if (response?.data?.status == "SUCCESS") {
                    localStorage.removeItem("payment_start_time");
                    localStorage.removeItem("payment_id");
                    localStorage.removeItem("mb_way_payment_request_id");
                    setPaymentId(null)
                    ToastAlert({ msg: "Tour Booked Successfully!", msgType: 'success' });
                    navigate(('/' + userLang) + '/booking-success/' + response?.data?.bookingId)
                } else {
                    if (response?.data?.status == "DECLINE") {
                        localStorage.removeItem("payment_start_time");
                        localStorage.removeItem("payment_id");
                        setPaymentId(null)
                        setStep(1)
                        ToastAlert({ msg: "Payment request rejected by user", msgType: 'error' });
                        setShowModal(false)

                    }
                    if (response?.data?.status == "TIMEOUT") {
                        localStorage.removeItem("payment_start_time");
                        localStorage.removeItem("payment_id");
                        setPaymentId(null)
                        setStep(1)
                        ToastAlert({ msg: "Payment request expired, please try again", msgType: 'error' });
                        setShowModal(false)
                    }
                }
            } else {
                if (response?.data?.message == 'Unauthorized' || response?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + userLang + '/login')
                }
                localStorage.removeItem("payment_start_time");
                localStorage.removeItem("payment_id");
                setPaymentId(null)
                setStep(1)
                setShowModal(false)
                ToastAlert({ msg: response?.data?.message, msgType: 'error' });
            }
        };

        const statusInterval = setInterval(checkPaymentStatus, 5000); // Call API every 5 sec

        return () => clearInterval(statusInterval);
    }, [paymentId]);

    useEffect(() => { // Multibanco
        const checkMBPaymentStatus = async () => {
            if (!MBpaymentId) return;
            const userLang = getSlugByLang(user?.language)
            const response = await ApiCall("post", "check-multibanco-request-status", { id: MBpaymentId }, user.token ? user.token : userLoginData?.token);
            if (response?.data?.success) {
                if (response?.data?.status == "SUCCESS") {
                    localStorage.removeItem("mb_payment_start_time");
                    localStorage.removeItem("mb_payment_id");
                    localStorage.removeItem("mb_payment_request_id");
                    setMBPaymentId(null)
                    ToastAlert({ msg: "Tour Booked Successfully!", msgType: 'success' });
                    navigate(('/' + userLang) + '/booking-success/' + response?.data?.bookingId)
                } else {
                    if (response?.data?.status == "DECLINE") {
                        localStorage.removeItem("mb_payment_start_time");
                        localStorage.removeItem("mb_payment_id");
                        setMBPaymentId(null)
                        // setStep(1)
                        ToastAlert({ msg: "Payment request rejected by user", msgType: 'error' });
                        setShowMBModal(false)

                    }
                    if (response?.data?.status == "TIMEOUT") {
                        localStorage.removeItem("mb_payment_start_time");
                        localStorage.removeItem("mb_payment_id");
                        setMBPaymentId(null)
                        // setStep(1)
                        ToastAlert({ msg: "Payment request expired, please try again", msgType: 'error' });
                        setShowMBModal(false)
                    }
                }
            } else {
                if (response?.data?.message == 'Unauthorized' || response?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + userLang + '/login')
                }
                localStorage.removeItem("mb_payment_start_time");
                localStorage.removeItem("mb_payment_id");
                setMBPaymentId(null)
                // setStep(1)
                setShowMBModal(false)
                ToastAlert({ msg: response?.data?.message, msgType: 'error' });
            }
        };

        const statusInterval = setInterval(checkMBPaymentStatus, 5000); // Call API every 10 sec

        return () => clearInterval(statusInterval);
    }, [MBpaymentId]);

    const sendMbwayPaymentRequest = async (phone) => {
        localStorage.removeItem("mb_way_payment_request_id");
        localStorage.removeItem("mb_payment_request_id");

        dispatch(setLoading(true))

        const storedQuestions = mainContactField.reduce((acc, { field_name, value }) => {
            if (field_name === "passportExpiry" || field_name === "dateOfBirth") {
                acc[field_name] = value ? moment(value).format("YYYY-MM-DD") : '';
            } else if (field_name === "title") {
                acc[field_name] = value?.toUpperCase()
            } else {
                acc[field_name] = value;
            }
            return acc;
        }, {});

        const passangerformattedData = passengers.map(person => ({
            ...person,
            fields: person.fields.map(field => ({
                ...field,
                value: (field.field_name === "passportExpiry" || field.field_name === "dateOfBirth")
                    ? (field.value ? moment(field.value).format("YYYY-MM-DD") : '')
                    : (field.field_name === "title") ? field.value?.toUpperCase()
                        : field.value
            }))
        }));

        let cartData = {}
        cartData.cartSession = cartDetail?.cartSession
        cartData.product_id = cartDetail?.product
        cartData.commission = productDetail?.commission
        cartData.payment_type = "mb_way"
        cartData.activity_date = cartDetail?.selectedDate
        cartData.order_id = cartItem?.id
        cartData.supplier_id = productDetail?.supplier_id
        cartData.mainContact = storedQuestions
        cartData.passangers = passangerformattedData
        cartData.amount = cartItem?.totalPrice
        cartData.mobile_number = phone
        cartData.description = productDetail?.title

        const sendRequest = await ApiCall('post', "send-mb-way-payment-request", cartData, user.token ? user.token : userLoginData?.token);
        dispatch(setLoading(false))
        if (sendRequest) {
            if (sendRequest?.data?.success) {
                setShowModal(true);
                setPaymentId(sendRequest.data.id);
                localStorage.setItem("payment_id", sendRequest?.data?.id);
                localStorage.setItem("mb_way_payment_request_id", sendRequest?.data?.id);
                localStorage.setItem("payment_start_time", Date.now());
            } else {
                if (sendRequest?.data?.message == 'Unauthorized' || sendRequest?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + selLang + '/login')
                }
                ToastAlert({ msg: sendRequest?.data?.message, msgType: 'error' });
            }
        }


        // console.log(cartData);


    }

    const generateMultiBancoRefrence = async () => {
        localStorage.removeItem("mb_way_payment_request_id");
        localStorage.removeItem("mb_payment_request_id");
        dispatch(setLoading(true))
        const storedQuestions = mainContactField.reduce((acc, { field_name, value }) => {
            if (field_name === "passportExpiry" || field_name === "dateOfBirth") {
                acc[field_name] = value ? moment(value).format("YYYY-MM-DD") : '';
            } else if (field_name === "title") {
                acc[field_name] = value?.toUpperCase()
            } else {
                acc[field_name] = value;
            }
            return acc;
        }, {});

        const passangerformattedData = passengers.map(person => ({
            ...person,
            fields: person.fields.map(field => ({
                ...field,
                value: (field.field_name === "passportExpiry" || field.field_name === "dateOfBirth")
                    ? (field.value ? moment(field.value).format("YYYY-MM-DD") : '')
                    : (field.field_name === "title") ? field.value?.toUpperCase()
                        : field.value
            }))
        }));

        let cartData = {}
        cartData.cartSession = cartDetail?.cartSession
        cartData.product_id = cartDetail?.product
        cartData.commission = productDetail?.commission
        cartData.activity_date = cartDetail?.selectedDate
        cartData.order_id = cartItem?.id
        cartData.supplier_id = productDetail?.supplier_id
        cartData.mainContact = storedQuestions
        cartData.passangers = passangerformattedData
        cartData.amount = cartItem?.totalPrice
        cartData.description = productDetail?.title

        const generateRef = await ApiCall('post', "generate-mb-payment-ref", cartData, user.token ? user.token : userLoginData?.token);
        dispatch(setLoading(false))
        if (generateRef) {
            if (generateRef?.data?.success) {
                ToastAlert({ msg: generateRef?.data?.message, msgType: 'success' });
                let res = {
                    Entity: generateRef?.data?.Entity,
                    Reference: generateRef?.data?.Reference,
                    RequestId: generateRef?.data?.RequestId,
                    Amount: generateRef?.data?.Amount,
                }
                setMbResponse(res)
                localStorage.setItem('mb_ref', JSON.stringify(res))
                localStorage.setItem('mb_exp', generateRef?.data?.ExpiryDate)

                setShowMBModal(true);
                setMBPaymentId(generateRef?.data?.id);
                localStorage.setItem("mb_payment_id", generateRef?.data?.id);
                localStorage.setItem("mb_payment_request_id", generateRef?.data?.id);
                localStorage.setItem("mb_payment_start_time", Date.now());

            } else {
                if (generateRef?.data?.message == 'Unauthorized' || generateRef?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + selLang + '/login')
                }
                ToastAlert({ msg: generateRef?.data?.message, msgType: 'error' });
            }
        } else {
            ToastAlert({ msg: "Something went wrong, please try again!", msgType: 'error' });

        }
    }

    useEffect(() => {
        if (activeTab == "multibanco") {
            if (localStorage.getItem('mb_ref')) {
                setMbResponse(JSON.parse(localStorage.getItem('mb_ref')))
            }
        }
    }, [activeTab]);

    const canceMultibancoPayment = async () => {
        if (!MBpaymentId) return;
        dispatch(setLoading(true))
        const response = await ApiCall("post", "cancel-multibanco-request", { id: MBpaymentId }, user.token ? user.token : userLoginData?.token);
        dispatch(setLoading(false))
        if (response?.data?.success) {
            localStorage.removeItem("mb_payment_start_time");
            localStorage.removeItem("mb_payment_id");
            setMBPaymentId(null)
            ToastAlert({ msg: response?.data?.message, msgType: 'success' });
            setShowMBModal(false)

        } else {
            ToastAlert({ msg: response?.data?.message, msgType: 'error' });
        }

    }

    const canceMBwayPayment = async () => {
        if (!paymentId) return;
        dispatch(setLoading(true))
        const response = await ApiCall("post", "cancel-mb-way-request", { id: paymentId }, user.token ? user.token : userLoginData?.token);
        dispatch(setLoading(false))
        if (response?.data?.success) {
            localStorage.removeItem("payment_start_time");
            localStorage.removeItem("payment_id");
            localStorage.removeItem("mb_way_payment_request_id");
            setPaymentId(null)
            setShowModal(false)
            ToastAlert({ msg: response?.data?.message, msgType: 'success' });
        } else {
            ToastAlert({ msg: response?.data?.message, msgType: 'error' });
        }
    }

    return (
        <>
            <PageTitle title={'Checkout'} />
            <Index
                cartDetail={cartDetail}
                productDetail={productDetail}
                mainContactField={mainContactField}
                passengerField={passengerField}
                passengers={passengers}
                handleChangePassenger={handleChangePassenger}
                handleChangeMainContact={handleChangeMainContact}
                selectedCountryOption={selectedCountryOption}
                handleCountrySelectChange={handleCountrySelectChange}
                onChangeCustomDropdown={onChangeCustomDropdown}
                onChangeDate={onChangeDate}
                selectedLanguageOption={selectedLanguageOption}
                handleLanguageSelectChange={handleLanguageSelectChange}
                handleNumberChange={handleNumberChange}
                handleValidityChange={handleValidityChange}
                onClickContinue={onClickContinue}
                user={user}
                state={state}
                changeValue={changeValue}
                breadcrumbList={breadcrumbList}
                totalGuest={totalGuest}
                showPassword={showPassword}
                handhandleShowPassword={handhandleShowPassword}
                getClassNames={getClassNames}
                step={step}
                activeTab={activeTab}
                onClickPaymentTab={onClickPaymentTab}
                setStep={setStep}
                cardState={cardState}
                onChangeCard={onChangeCard}
                stripeSuccess={stripeSuccess}
                isLoading={isLoading}

                sendMbwayPaymentRequest={sendMbwayPaymentRequest}

                mbResponse={mbResponse}
                isMBLoading={isMBLoading}

                generateMultiBancoRefrence={generateMultiBancoRefrence}
                today={today}

                isLoginForm={isLoginForm}
                setIsLoginForm={setIsLoginForm}

                cartItem={cartItem}

                isAdmin={isAdmin}

            />
            <VerificationModal
                show={showVerificatonModal}
                handleClose={handleCloseVerificatonModal}
                verify={verify}
                verifyState={verifyState}
                changeValueOtp={changeValueOtp}
                handlePaste={handlePaste}
                canResend={canResend}
                timer={timer}
                resendOtp={resendOtp}
                formatTime={formatTime}

            />

            <MBWayModal
                showModal={showModal}
                timeLeft={timeLeft}
                canceMBwayPayment={canceMBwayPayment}
            />

            <MultiBancoModal
                showMBModal={showMBModal}
                MBtimeLeft={MBtimeLeft}
                mbResponse={mbResponse}
                canceMultibancoPayment={canceMultibancoPayment}
            />

        </>
    )
}